import React from 'react'
import { Link as ScrollLink } from 'react-scroll'
import { Link as RouterLink } from 'react-router-dom'
import { motion } from 'framer-motion'
import './SideBar.css'

const SideBar = ({ optionClickHandler }) => {

    const sections = [
        { id: 'home', title: 'Home' },
        { id: 'about-the-founder', title: 'About the Founder' },
        { id: 'contact-us', title: 'Contact Us' },
    ]

    return (
        <motion.div
            className='sidebar'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            onClick={optionClickHandler}
        >
            <motion.div
                className='sidebar-panel'
                initial={{ x: '100%' }}
                animate={{ x: 0 }}
                exit={{ x: '100%' }}
                transition={{ duration: 0.35, ease: [0.32, 0, 0.18, 1] }}
                onClick={(e) => e.stopPropagation()}
            >
                <ul>
                    {sections.map((section) => (
                        <li key={section.id}>
                            <ScrollLink
                                to={section.id}
                                spy={true}
                                smooth={'easeInOutQuart'}
                                duration={1500}
                                id={`${section.id}-link`}
                                onClick={optionClickHandler}
                            >
                                {section.title}
                            </ScrollLink>
                        </li>
                    ))}
                    <li>
                        <RouterLink to="/projects" onClick={optionClickHandler}>
                            Explore Our Work
                        </RouterLink>
                    </li>
                </ul>
            </motion.div>
        </motion.div>
    )
}

export default SideBar
